import React from "react";

const LockedInSpace = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9.75479C5 9.38054 5.30339 9.07715 5.67764 9.07715H12.5724C12.9466 9.07715 13.25 9.38054 13.25 9.75479V14.0515C13.25 14.5755 12.8253 15.0002 12.3013 15.0002H5.9487C5.42475 15.0002 5 14.5755 5 14.0515V9.75479Z"
        fill="black"
      />
      <path
        d="M6.5 8.99985C6.5 6.24992 7 4.87505 9 4.87505C11 4.87505 11.5 6.25004 11.5 8.99985"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};

export default LockedInSpace;
